<div class="container">

    <div class="content">
        <h2><ion-icon name="mail-outline" class="mail-icon"></ion-icon> {{ 'VERIFY_YOUR_EMAIL' | translate }}</h2>
        <h3>{{ 'EMAIL_SENT_TO' | translate }}<b>{{emailToVerify}}</b>, {{ 'CLICK_LINK_TO_LOGIN' | translate }}</h3>
        <h3>{{ 'IF_NOT_RECEIVED_CHECK_SPAM' | translate }}</h3>
    </div>

</div>